__turbopack_context__.v({
  "root": "BottomBar-module__AnPLYq__root",
});
